import React, { useMemo, useState } from 'react';
import { supabase } from '../supabase';
import { motion, AnimatePresence } from 'framer-motion';
import { Brain, ArrowRight, RotateCcw, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/Button';
const baseQuestions = [
// Realistic
{
  id: 1,
  text: 'Saya menyukai mengulik peralatan',
  category: 'Realistic'
}, {
  id: 2,
  text: 'Saya menyukai menyusun balok/LEGO',
  category: 'Realistic'
}, {
  id: 3,
  text: 'Saya menyukai memelihara binatang',
  category: 'Realistic'
}, {
  id: 4,
  text: 'Saya menyukai mencari tahu cara kerja sebuah alat',
  category: 'Realistic'
}, {
  id: 5,
  text: 'Saya menyukai merangkai atau merakit benda',
  category: 'Realistic'
}, {
  id: 6,
  text: 'Saya menyukai memasak',
  category: 'Realistic'
}, {
  id: 7,
  text: 'Saya menyukai mempraktikkan hal-hal yang dipelajari',
  category: 'Realistic'
}, {
  id: 8,
  text: 'Saya menyukai berkegiatan di luar ruangan',
  category: 'Realistic'
},
// Investigative
{
  id: 9,
  text: 'Saya menyukai mengerjakan puzzle',
  category: 'Investigative'
}, {
  id: 10,
  text: 'Saya menyukai melakukan percobaan/eksperimen',
  category: 'Investigative'
}, {
  id: 11,
  text: 'Saya menyukai membantu orang lain memecahkan persoalan',
  category: 'Investigative'
}, {
  id: 12,
  text: 'Saya menyukai sains',
  category: 'Investigative'
}, {
  id: 13,
  text: 'Saya menyukai memperhatikan detail',
  category: 'Investigative'
}, {
  id: 14,
  text: 'Saya menyukai mencari tahu penyebab suatu kejadian',
  category: 'Investigative'
}, {
  id: 15,
  text: 'Saya menyukai mengerjakan soal matematika atau grafik',
  category: 'Investigative'
}, {
  id: 16,
  text: 'Saya menyukai menghitung',
  category: 'Investigative'
},
// Artistic
{
  id: 17,
  text: 'Saya menyukai membaca buku tentang seni dan musik',
  category: 'Artistic'
}, {
  id: 18,
  text: 'Saya menyukai membuat karya berbentuk tulisan',
  category: 'Artistic'
}, {
  id: 19,
  text: 'Saya menyukai kegiatan kreatif',
  category: 'Artistic'
}, {
  id: 20,
  text: 'Saya menyukai memainkan alat musik atau bernyanyi',
  category: 'Artistic'
}, {
  id: 21,
  text: 'Saya menyukai mempelajari budaya berbagai daerah',
  category: 'Artistic'
}, {
  id: 22,
  text: 'Saya menyukai bermain peran/drama',
  category: 'Artistic'
}, {
  id: 23,
  text: 'Saya menyukai menggambar',
  category: 'Artistic'
},
// Social
{
  id: 24,
  text: 'Saya menyukai bekerja dalam kelompok',
  category: 'Social'
}, {
  id: 25,
  text: 'Saya menyukai menjelaskan sesuatu kepada teman',
  category: 'Social'
}, {
  id: 26,
  text: 'Saya menyukai membantu orang lain memecahkan persoalan',
  category: 'Social'
}, {
  id: 27,
  text: 'Saya menyukai menghibur teman',
  category: 'Social'
}, {
  id: 28,
  text: 'Saya menyukai mendiskusikan hal-hal yang terjadi di sekitar',
  category: 'Social'
}, {
  id: 29,
  text: 'Saya menyukai menolong orang',
  category: 'Social'
}, {
  id: 30,
  text: 'Saya menyukai berbicara di depan umum',
  category: 'Social'
},
// Enterprising
{
  id: 31,
  text: 'Saya menyukai membuat target untuk diri sendiri',
  category: 'Enterprising'
}, {
  id: 32,
  text: 'Saya menyukai meyakinkan teman untuk mengikuti cara saya',
  category: 'Enterprising'
}, {
  id: 33,
  text: 'Saya menyukai bekerja melebihi waktu yang ditentukan',
  category: 'Enterprising'
}, {
  id: 34,
  text: 'Saya menyukai menjual sesuatu',
  category: 'Enterprising'
}, {
  id: 35,
  text: 'Saya menyukai tantangan baru',
  category: 'Enterprising'
}, {
  id: 36,
  text: 'Saya menyukai kegiatan berwirausaha',
  category: 'Enterprising'
}, {
  id: 37,
  text: 'Saya menyukai memimpin kelompok atau kelas',
  category: 'Enterprising'
}, {
  id: 38,
  text: 'Saya menyukai berbicara di depan umum',
  category: 'Enterprising'
},
// Conventional
{
  id: 39,
  text: 'Saya menyukai merapikan barang-barang',
  category: 'Conventional'
}, {
  id: 40,
  text: 'Saya menyukai mengerjakan hal-hal dengan instruksi yang jelas',
  category: 'Conventional'
}, {
  id: 41,
  text: 'Saya menyukai memperhatikan detail',
  category: 'Conventional'
}, {
  id: 42,
  text: 'Saya menyukai merapikan catatan atau LKS',
  category: 'Conventional'
}, {
  id: 43,
  text: 'Saya menyukai merapikan kamar',
  category: 'Conventional'
}, {
  id: 44,
  text: 'Saya menyukai berkegiatan di dalam ruangan dengan meja-kursi',
  category: 'Conventional'
}, {
  id: 45,
  text: 'Saya menyukai menghitung',
  category: 'Conventional'
}];
const options = [{
  value: 1,
  label: 'Sangat Tidak Setuju'
}, {
  value: 2,
  label: 'Tidak Setuju'
}, {
  value: 3,
  label: 'Netral'
}, {
  value: 4,
  label: 'Setuju'
}, {
  value: 5,
  label: 'Sangat Setuju'
}];
function shuffleArray(array: typeof baseQuestions) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
export function Asesmen() {
  const [started, setStarted] = useState(false);
  const [currentQ, setCurrentQ] = useState(0);
  const [answers, setAnswers] = useState<Record<number, number>>({});
  const [showResult, setShowResult] = useState(false);
  const [saving, setSaving] = useState(false);
  const [studentData, setStudentData] = useState({
    nama: '',
    kelas: '',
    sekolah: ''
  });
  const questions = useMemo(() => shuffleArray(baseQuestions), []);
  const calculateResult = () => {
    const scores: Record<string, number> = {};
    questions.forEach(q => {
      const score = answers[q.id] ?? 0;
      scores[q.category] = (scores[q.category] || 0) + score;
    });
    if (Object.keys(scores).length === 0) {
      return 'Social';
    }
    const dominantCategory = Object.keys(scores).reduce((a, b) => scores[a] > scores[b] ? a : b);
    return dominantCategory;
  };
  const saveResult = async () => {
    setSaving(true);
    const scores: Record<string, number> = {};
    questions.forEach(q => {
      const score = answers[q.id] ?? 0;
      scores[q.category] = (scores[q.category] || 0) + score;
    });
    const dominant = calculateResult();
    const {
      data,
      error
    } = await supabase.from('hasil_asesmen_riasec').insert({
      nama: studentData.nama,
      kelas: studentData.kelas,
      sekolah: studentData.sekolah,
      realistic: scores.Realistic || 0,
      investigative: scores.Investigative || 0,
      artistic: scores.Artistic || 0,
      social: scores.Social || 0,
      enterprising: scores.Enterprising || 0,
      conventional: scores.Conventional || 0,
      dominant_type: dominant
    }).select();
    setSaving(false);
  };
  const handleAnswer = (value: number) => {
    setAnswers(prev => ({
      ...prev,
      [questions[currentQ].id]: value
    }));
    if (currentQ < questions.length - 1) {
      setTimeout(() => setCurrentQ(prev => prev + 1), 300);
    } else {
      setTimeout(async () => {
        await saveResult();
        setShowResult(true);
      }, 300);
    }
  };
  const resetTest = () => {
    setStarted(false);
    setCurrentQ(0);
    setAnswers({});
    setShowResult(false);
  };
  const renderResult = () => {
    const dominant = calculateResult();
    const resultDescriptions: Record<string, {
      title: string;
      desc: string;
      color: string;
    }> = {
      Realistic: {
        title: 'Praktis & Teknis',
        desc: 'Kamu menyukai praktik langsung, nyaman bekerja dengan alat dan mesin, aktif secara fisik, berpikir praktis, serta cenderung tidak terlalu menyukai aktivitas yang banyak melibatkan interaksi sosial. Individu dengan tipe ini cocok menekuni karier sebagai teknisi, mekanik, field engineer, pekerja konstruksi, drone operator, pekerja agribisnis, atau teknisi maintenance di industri.',
        color: 'bg-orange-100 text-orange-800'
      },
      Investigative: {
        title: 'Analitis & Peneliti',
        desc: 'Kamu senang berpikir, menganalisis, dan memecahkan masalah. Mereka memiliki rasa ingin tahu yang tinggi, gemar mempelajari hal-hal baru, terutama yang bersifat ilmiah, serta lebih nyaman bekerja secara mandiri. Karier yang sesuai antara lain peneliti, data analyst, data scientist, programmer, software developer, dokter, dosen, analis laboratorium, dan ahli forensik.',
        color: 'bg-blue-100 text-blue-800'
      },
      Artistic: {
        title: 'Kreatif & Ekspresif',
        desc: 'Kamu memiliki sifat kreatif, imajinatif, ekspresif, dan memiliki kepekaan terhadap estetika. Individu tipe ini cenderung menyukai kebebasan dalam berkarya dan kurang menyukai aturan yang terlalu kaku. Karier yang cocok meliputi desainer grafis, UI/UX designer, content creator, seniman, musisi, penulis, fotografer, videografer, animator, serta fashion designer.',
        color: 'bg-pink-100 text-pink-800'
      },
      Social: {
        title: 'Peduli & Komunikatif',
        desc: 'Kamu senang berinteraksi dengan orang lain, memiliki kepedulian tinggi, komunikatif, ramah, serta suka membantu sesama. Mereka juga memiliki kemampuan bekerja sama dan empati yang baik. Oleh karena itu, karier yang sesuai antara lain guru, konselor, psikolog, perawat, tenaga kesehatan, pekerja sosial, HR, trainer, fasilitator, dan penyuluh.',
        color: 'bg-green-100 text-green-800'
      },
      Enterprising: {
        title: 'Pemimpin & Persuasif',
        desc: 'Kamu adalah orang yang percaya diri, berani mengambil risiko, suka memimpin, persuasif, energik, dan menyukai tantangan. Individu dengan tipe ini umumnya tertarik pada pekerjaan yang melibatkan kepemimpinan dan pengambilan keputusan. Karier yang cocok meliputi pengusaha, sales, marketing, public relations, manajer, supervisor, politisi, event organizer, dan business development.',
        color: 'bg-purple-100 text-purple-800'
      },
      Conventional: {
        title: 'Teratur & Detail',
        desc: 'Kamu menyukai keteraturan, kerapihan, ketelitian, serta bekerja berdasarkan aturan dan prosedur yang jelas. Mereka juga cenderung menyukai aktivitas yang berhubungan dengan angka dan data. Karier yang sesuai untuk tipe ini adalah admin, staf administrasi, akuntan, data entry, data analyst, staf keuangan, teller bank, dan sekretaris.',
        color: 'bg-gray-200 text-gray-800'
      }
    };
    const resultInfo = resultDescriptions[dominant] || resultDescriptions['Social'];
    return <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="bg-white rounded-3xl p-8 md:p-12 border border-pastel-grey shadow-apple text-center" data-id="element-140">
        <div className="w-20 h-20 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-141">
          <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-142" />
        </div>

        <h2 className="text-2xl font-bold text-dark mb-2" data-id="element-143">
          Hasil Asesmen RIASEC
        </h2>

        <p className="text-gray-500 mb-8" data-id="element-144">
          Berdasarkan jawabanmu, tipe dominanmu adalah:
        </p>

        <div className={`inline-block px-6 py-3 rounded-2xl ${resultInfo.color} mb-6`} data-id="element-145">
          <h3 className="text-3xl font-bold" data-id="element-146">{dominant}</h3>
          <p className="font-medium opacity-80" data-id="element-147">{resultInfo.title}</p>
        </div>

        <p className="text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-148">
          {resultInfo.desc}
        </p>

        <Button onClick={resetTest} variant="outline" data-id="element-149">
          <RotateCcw size={18} className="mr-2" data-id="element-150" />
          Ulangi Asesmen
        </Button>
      </motion.div>;
  };
  return <div className="min-h-screen bg-pastel-grey-light/30 py-12" data-id="element-151">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        {!started && !showResult && <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-3xl p-8 md:p-12 border border-pastel-grey shadow-sm text-center" data-id="element-153">
            <div className="w-20 h-20 mx-auto bg-pastel-blue-light rounded-2xl flex items-center justify-center mb-8" data-id="element-154">
              <Brain className="w-10 h-10 text-blue-600" data-id="element-155" />
            </div>

            <h1 className="text-4xl font-bold text-dark mb-4" data-id="element-156">
              Asesmen Minat & Bakat RIASEC
            </h1>

            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-157">
              Kenali potensi dan kecenderungan kariermu melalui asesmen RIASEC.
            </p>

            <div className="space-y-4 max-w-md mx-auto mb-8 text-left" data-id="element-158">
              <input type="text" placeholder="Nama Lengkap" value={studentData.nama} onChange={e => setStudentData({
            ...studentData,
            nama: e.target.value
          })} className="w-full border border-pastel-grey rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-dark/10" data-id="element-159" />

              <input type="text" placeholder="Kelas" value={studentData.kelas} onChange={e => setStudentData({
            ...studentData,
            kelas: e.target.value
          })} className="w-full border border-pastel-grey rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-dark/10" data-id="element-160" />

              <input type="text" placeholder="Sekolah" value={studentData.sekolah} onChange={e => setStudentData({
            ...studentData,
            sekolah: e.target.value
          })} className="w-full border border-pastel-grey rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-dark/10" data-id="element-161" />
            </div>

            <Button size="lg" onClick={() => {
          if (!studentData.nama || !studentData.kelas || !studentData.sekolah) {
            alert('Lengkapi biodata terlebih dahulu');
            return;
          }
          setStarted(true);
        }} data-id="element-162">
              Mulai Asesmen
              <ArrowRight size={20} className="ml-2" data-id="element-163" />
            </Button>
          </motion.div>}

        {started && !showResult && <div className="max-w-2xl mx-auto" data-id="element-164">
            <div className="mb-8" data-id="element-165">
              <div className="flex justify-between text-sm text-gray-500 mb-2" data-id="element-166">
                <span data-id="element-167">
                  Pertanyaan {currentQ + 1} dari {questions.length}
                </span>

                <span data-id="element-168">
                  {Math.round((currentQ + 1) / questions.length * 100)}%
                </span>
              </div>

              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-169">
                <div className="bg-dark h-2.5 rounded-full transition-all duration-300 ease-out" style={{
              width: `${(currentQ + 1) / questions.length * 100}%`
            }} data-id="element-170"></div>
              </div>
            </div>

            <AnimatePresence mode="wait" data-id="element-171">
              <motion.div key={currentQ} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.2
          }} className="bg-white rounded-3xl p-8 border border-pastel-grey shadow-apple" data-id="element-172">
                <h2 className="text-2xl font-semibold text-dark mb-8 leading-relaxed" data-id="element-173">
                  {questions[currentQ].text}
                </h2>

                <div className="space-y-3" data-id="element-174">
                  {options.map(opt => <button key={opt.value} onClick={() => handleAnswer(opt.value)} className={`w-full text-left px-6 py-4 rounded-xl border transition-all duration-200 ${answers[questions[currentQ].id] === opt.value ? 'border-dark bg-dark text-white' : 'border-pastel-grey hover:border-dark hover:bg-pastel-grey-light text-gray-700'}`} data-id="element-175">
                      {opt.label}
                    </button>)}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>}

        {showResult && renderResult()}
      </div>
    </div>;
}